<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ housekeepingServFeeConfigManageRelInfo.servName }}费用</span>
            <div>
              <el-button type="primary" size="small"
                @click="_openAddHousekeepingFeeConfigRel(housekeepingServFeeConfigManageRelInfo.servId, housekeepingServFeeConfigManageRelInfo.servName)">
                <i class="el-icon-plus"></i>添加
              </el-button>
              <el-button type="primary" size="small" @click="_openHousekeepingServManages()">
                <i class="el-icon-close"></i>返回
              </el-button>
            </div>
          </div>

          <el-table :data="housekeepingServFeeConfigManageRelInfo.housekeepingServFeeConfigRels" style="width: 100%"
            border stripe>
            <el-table-column prop="typeName" label="费用大类" align="center">
            </el-table-column>
            <el-table-column prop="feeName" label="费用名称" align="center">
            </el-table-column>
            <el-table-column prop="computingFormula" label="计算公式" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.computingFormula == '1001'">面积*单价</span>
                <span v-else-if="scope.row.computingFormula == '2002'">固定费用</span>
                <span v-else-if="scope.row.computingFormula == '3003'">费用面议</span>
              </template>
            </el-table-column>
            <el-table-column prop="feePrice" label="收费金额" align="center">
            </el-table-column>
            <el-table-column prop="marketPrice" label="市场价" align="center">
            </el-table-column>
            <el-table-column prop="startTime" label="开始时间" align="center">
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="danger"
                  @click="_openDeleteHousekeepingServFeeConfigRelModal(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="housekeepingServFeeConfigManageRelInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-housekeeping-fee-config-rel ref="addHousekeepingFeeConfigRel" @refresh="query()"></add-housekeeping-fee-config-rel>
    <delete-housekeeping-serv-fee-config-rel
      ref="deleteHousekeepingServFeeConfigRel" @refresh="query()"></delete-housekeeping-serv-fee-config-rel>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryHousekeepingServConfig } from '@/api/housekeeping/housekeepingServFeeApi'
import AddHousekeepingFeeConfigRel from '@/components/housekeeping/addHousekeepingFeeConfigRel'
import DeleteHousekeepingServFeeConfigRel from '@/components/housekeeping/deleteHousekeepingServFeeConfigRel'

export default {
  name: 'HousekeepingServFeeConfigManageRel',
  components: {
    AddHousekeepingFeeConfigRel,
    DeleteHousekeepingServFeeConfigRel
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      housekeepingServFeeConfigManageRelInfo: {
        housekeepingServFeeConfigRels: [],
        total: 0,
        records: 1,
        servId: '',
        servName: '',
        conditions: {
          feeName: '',
          startTime: '',
          endTime: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.housekeepingServFeeConfigManageRelInfo.conditions.shopId = getShopId()
    this._listHousekeepingServFeeConfigRels(this.currentPage, this.pageSize)
  },
  methods: {
    query(){
      this._listHousekeepingServFeeConfigRels(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this._listHousekeepingServFeeConfigRels(val, this.pageSize)
    },
    _listHousekeepingServFeeConfigRels(page, rows) {
      this.housekeepingServFeeConfigManageRelInfo.conditions.page = page
      this.housekeepingServFeeConfigManageRelInfo.conditions.row = rows
      queryHousekeepingServConfig(this.housekeepingServFeeConfigManageRelInfo.conditions)
        .then(res => {
          this.housekeepingServFeeConfigManageRelInfo.total = res.total
          this.housekeepingServFeeConfigManageRelInfo.records = res.records
          this.housekeepingServFeeConfigManageRelInfo.housekeepingServFeeConfigRels = res.data
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
    },
    _openDeleteHousekeepingServFeeConfigRelModal(row) {
      this.$refs.deleteHousekeepingServFeeConfigRel.open(row)
    },
    _openAddHousekeepingFeeConfigRel(servId, servName) {
      this.$refs.addHousekeepingFeeConfigRel.open({
        _servId: servId,
        _servName: servName
      })
    },
    _openHousekeepingServManages() {
      this.$router.push('/pages/housekeeping/housekeepingServ')
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>